// Dates on the public pages, in the page's language (Intl, no date-fns: these pages
// only show a few fixed dates). Dates are YYYY-MM-DD, months YYYY-MM.

const format = (iso, lang, opts) =>
  new Intl.DateTimeFormat(lang, { ...opts, timeZone: 'UTC' }).format(new Date(`${iso}T12:00:00Z`));

/** "October 30, 2026" */
export const longDate = (iso, lang) => format(iso, lang, { year: 'numeric', month: 'long', day: 'numeric' });

/** "Mar 15, 2026" */
export const shortDate = (iso, lang) => format(iso, lang, { year: 'numeric', month: 'short', day: 'numeric' });

/** "March 2026", capitalized like a heading in every language */
export const monthAndYear = (month, lang) => {
  const s = format(`${month}-15`, lang, { year: 'numeric', month: 'long' });
  return s.charAt(0).toLocaleUpperCase(lang) + s.slice(1);
};
